import * as React from 'react'
import clsx from 'clsx'

import styles from './SectionHead.module.css'

export type SectionHeadProps = {
  /** Small uppercase label above the title. */
  kicker?: React.ReactNode
  title: React.ReactNode
  lede?: React.ReactNode
  /**
   * Scale variant: 'md' (default), 'lg' — a larger display title + ink-colored lede (Press) — or
   * 'wide', a longer title measure and a one-step-larger lede (Statistiques).
   */
  size?: 'md' | 'lg' | 'wide'
  className?: string
}

/** Shared section heading: a serif display `h2` + an optional sans lede. Used across the static pages. */
export function SectionHead({ kicker, title, lede, size = 'md', className }: SectionHeadProps): React.ReactElement {
  return (
    <div className={clsx(styles.head, size === 'lg' && styles.headLg, size === 'wide' && styles.headWide, className)}>
      {kicker !== undefined ? <p className={styles.head__kicker}>{kicker}</p> : null}
      <h2 className={styles.head__title}>{title}</h2>
      {lede !== undefined ? <p className={styles.head__lede}>{lede}</p> : null}
    </div>
  )
}

/** Red italic run inside a `SectionHead` title, for the part the design sets apart. */
export function SectionHeadHighlight({ children }: { children: React.ReactNode }): React.ReactElement {
  return <span className={styles.head__titleHighlight}>{children}</span>
}
